import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isAfter } from 'date-fns';
import { Form, Input, message } from 'antd';
import { useAuth } from '../../../hooks/auth';
import { redirectUrlInRoles } from '../../../helpers/utils';
import { getAtendimentoEmAndamento } from '../../../services';

import UserVetor from '../../../assets/icons/User/UserVetor';
import KeyVetor from '../../../assets/icons/KeyVetor/KeyVetor';
import * as S from '../styles';

export const obterRedirecionamentoInicial = async (
  permissoes = [],
  buscarAtendimento = getAtendimentoEmAndamento
) => {
  const redirectNotAtendimento = () => {
    const itemRoles = [
      'MenuPainelControle',
      'Operador',
      'MenuConsultasExternas',
      'MenuAtendimentoExterno',
      'OperadorExterno',
    ];
    const permissoesDeEntrada = permissoes.filter(item =>
      itemRoles.includes(item)
    );
    const role =
      permissoesDeEntrada.length > 1
        ? 'MenuPainelControle'
        : permissoesDeEntrada[0] || permissoes[0];

    return redirectUrlInRoles(role);
  };

  try {
    const { data } = await buscarAtendimento();

    return data?.idTipoValidacao === 1
      ? { url: '/painel-de-controle', atendimento: data }
      : { url: redirectNotAtendimento() };
  } catch (error) {
    return { url: redirectNotAtendimento() };
  }
};

function Login({ onClickEsqueci, setRender }) {
  const [loading, setLoading] = React.useState(false);
  const { signIn, buscarPermissoes } = useAuth();
  const history = useHistory();

  useEffect(() => {
    autoLogin();
  }, []);

  const autoLogin = async () => {
    setLoading(true);
    const expiry_date_token = localStorage.getItem(
      '@TmovGR:expiry_date_refresh_token'
    );

    const isExpiry = isAfter(new Date(expiry_date_token), new Date(Date.now()));

    setLoading(false);

    return isExpiry ? isLoged() : localStorage.clear();
  };

  const isLoged = async () => {
    setLoading(true);
    const listPermissoes = await buscarPermissoes();
    const redirect = await obterRedirecionamentoInicial(listPermissoes);

    setLoading(false);
    if (redirect) {
      return history.push(redirect?.url, redirect?.atendimento);
    }
  };

  const entrar = React.useCallback(
    async form => {
      try {
        setLoading(true);

        await signIn({
          username: form.login,
          password: form.senha,
        });

        const listPermissoes = (await buscarPermissoes()) || [];

        return listPermissoes?.length
          ? isLoged()
          : message.error(
              'Você não possui permissoes, entre em contato com administrador.'
            );
      } catch (err) {
        setLoading(false);
        message.error('Verifique suas credenciais');
      }
    },
    [signIn, buscarPermissoes]
  );

  return (
    <S.FormAntd
      onFinish={entrar}
      layout="vertical"
      id="form"
      requiredMark={false}
    >
      <S.FormHeading>
        <h1>Boas-vindas!</h1>
        <p aria-label="titleLogin">Faça seu login para continuar</p>
      </S.FormHeading>
      <Form.Item
        name="login"
        label="CPF"
        htmlFor="inputCpf"
        rules={[{ required: true, message: 'Por favor, entre com seu cpf!' }]}
      >
        <S.CpfInput
          prefix={<UserVetor />}
          size="large"
          mask="000.000.000-00"
          placeholder="CPF"
          autoComplete="username"
          inputMode="numeric"
          id="inputCpf"
        />
      </Form.Item>
      <Form.Item
        name="senha"
        label="Senha"
        htmlFor="password"
        rules={[{ required: true, message: 'Por favor, entre com sua senha!' }]}
      >
        <Input.Password
          prefix={<KeyVetor />}
          size="large"
          placeholder="Senha"
          autoComplete="current-password"
          id="password"
        />
      </Form.Item>
      <S.PrimaryButton
        size="large"
        htmlType="submit"
        data-testid="entrarBtn"
        id="entrar"
        loading={loading}
        aria-hidden={loading}
      >
        Entrar
      </S.PrimaryButton>
      <S.CenteredAction>
        <S.LinkButton
          onClick={onClickEsqueci}
          type="link"
          data-testid="esqueciSenha"
        >
          Esqueci minha senha
        </S.LinkButton>
      </S.CenteredAction>
      <S.Separator>Ou</S.Separator>
      <S.SecondaryButton
        size="large"
        data-testid="cadastrarBtn"
        id="Cadastrar"
        onClick={() => setRender('Cadastrar')}
      >
        Cadastre-se
      </S.SecondaryButton>
    </S.FormAntd>
  );
}

Login.propTypes = {
  onClickEsqueci: PropTypes.func,
  setRender: PropTypes.func,
};

Login.defaultProps = {
  onClickEsqueci: () => {},
  setRender: () => {},
};

export default Login;
